import axios from 'axios';

export const generateHttpClient = (baseURL: string, requestId?: string) =>
  axios.create({
    baseURL,
    timeout: 20000,
    headers: {
      Accept: 'application/json',
      'X-Request-ID': requestId,
    },
  });
